// New recordings live only in this page's memory. Historical IndexedDB data is untouched.
const clips=new Map();
const validKey=id=>typeof id==='string'&&/^account:[^:]+:.+$/u.test(id);
export async function saveAudio(id,blob){
 if(!validKey(id))throw Error('Sélectionnez une correction du compte connecté avant de conserver un audio.');
 if(!(blob instanceof Blob))throw Error('Audio invalide.');
 clips.set(id,blob);
}
export async function getAudio(id){return validKey(id)?clips.get(id)||null:null;}
export function hasAccountAudio(ownerId){
 if(typeof ownerId!=='string'||!ownerId)return false;
 const prefix='account:'+ownerId+':';
 return [...clips.keys()].some(key=>key.startsWith(prefix));
}
export function clearAccountAudio(ownerId){
 if(typeof ownerId!=='string'||!ownerId)return;
 const prefix='account:'+ownerId+':';
 for(const key of clips.keys())if(key.startsWith(prefix))clips.delete(key);
}
// Compatibility name: purges only new, in-memory clips, never a historical database.
export async function deleteAccountAudio(ownerId){clearAccountAudio(ownerId);}
